import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetSearchModel } from '../../models/search.model';
import { WidgetID } from '../../models/widget.model';

// identifier
export const SEARCH_SLICE_ID = 'search';

// default state
const initialState: WidgetSearchModel = {
  query: '',
  widgetSearchQuery: {},
};

export interface WidgetSearchPayload {
  widgetId: string;
  widgetSearchString: string;
}

//slice
const searchSlice = createSlice({
  name: SEARCH_SLICE_ID,
  initialState,
  reducers: {
    setSearchQuery: (state: WidgetSearchModel, action: PayloadAction<string>): void => {
      state.query = action.payload;
    },
    clearSearchQuery: (state: WidgetSearchModel): void => {
      state.query = '';
    },
    setWidgetSearchQuery: (
      state: WidgetSearchModel,
      action: PayloadAction<WidgetSearchPayload>
    ): void => {
      state.widgetSearchQuery[action.payload.widgetId] = action.payload.widgetSearchString;
    },
    clearWidgetSearchQuery: (state: WidgetSearchModel): void => {
      state.query = '';
      state.widgetSearchQuery = {};
    },
  },
});

//selectors
export const selectSearchQuery = (state: RootState) => state.search.query;
export const selectWidgetSearchQuery = createSelector(
  [
    (state: RootState) => state.search.widgetSearchQuery,
    (state: RootState, widgetId: WidgetID) => widgetId,
  ],
  (widgetSearchQuery, widgetId): string => {
    return widgetSearchQuery[widgetId] ?? '';
  }
);

//actions
export const { setSearchQuery, setWidgetSearchQuery, clearWidgetSearchQuery } = searchSlice.actions;

//reducer
export default searchSlice;
